import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

const UserGuidePage = lazy(() => import('~/features/user-guide/page-client'));

export const Route = createFileRoute('/_authed/user-guide')({
	component: () => (
		<Suspense fallback={null}>
			<UserGuidePage />
		</Suspense>
	),
});
